export enum Role {
    FreshbedAdmin = "Freshbed admin",
    HotelChain = "Hotel chain"
}